/* eslint-disable */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  // {
  //   path: "/about",
  //   component: () => import("../views/AboutView.vue"),
  // },
  {
    path: "/news",
    component: () => import("../views/NewsHome.vue"),
  },
  {
    path: "/works",
    component: () => import("../views/WorksHome.vue"),
  },
  {
    path: "/test",
    component: () => import("../views/TestView.vue"),
  },
  // {
  //   path: "/testflow",
  //   component: () => import("../views/TestFlowView.vue"),
  // },
  // {
  //   path: "/work",
  //   component: () => import("../views/WorkView.vue"),
  // },
  // {
  //   path: "/finance",
  //   component: () => import("../views/FinanceView.vue"),
  // },
  // // 금융 커버트골 풍차돌리기기
  // {
  //   path: "/finance_coverdcall",
  //   component: () => import("../views/FinanceCoverdCallView.vue"),
  // },
  // //
  // {
  //   path: "/policy",
  //   component: () => import("../views/ac/ACPolicyView.vue"),
  // },
  //
  // THIS SIDNFT WEB
  {
    path: "/sidnft_policy",
    component: () => import("../views/SidnftPrivateView.vue"),
  },
  {
    path: "/sidnft_service",
    component: () => import("../views/SidnftServiceView.vue"),
  },
  // DISCORD
  {
    path: "/discord_policy",
    component: () => import("../views/SidnftPrivateView.vue"),
  },
  {
    path: "/discord_terms",
    component: () => import("../views/SidnftServiceView.vue"),
  },
  // Add Force 1 project
  {
    path: "/af",
    component: () => import("../views/af/AFHomeView.vue"),
  },
  {
    path: "/af/policy",
    component: () => import("../views/af/AFPolicyView.vue"),
  },
  // brick away project
  {
    path: "/ba",
    component: () => import("../views/ba/BAHomeView.vue"),
  },
  {
    path: "/ba/policy",
    component: () => import("../views/ba/BAPolicyView.vue"),
  },
  // brick away project
  {
    path: "/eb",
    component: () => import("../views/eb/EBHomeView.vue"),
  },
  {
    path: "/eb/policy",
    component: () => import("../views/eb/EBPolicyView.vue"),
  },
  // aqua clock project
  // 서비스 종료
  // {
  //   path: "/ac",
  //   component: () => import("../views/ac/ACHomeView.vue"),
  // },
  // {
  //   path: "/ac/policy",
  //   component: () => import("../views/ac/ACPolicyView.vue"),
  // },
  // Block Build project
  {
    path: "/bb",
    component: () => import("../views/bb/BBHomeView.vue"),
  },
  {
    path: "/bb/policy",
    component: () => import("../views/bb/BBPolicyView.vue"),
  },
  // JCAT
  {
    path: "/jcat",
    component: () => import("../views/jcat/JCATHomeView.vue"),
  },
  {
    path: "/jcat/policy",
    component: () => import("../views/jcat/JCATPolicyView.vue"),
  },
  {
    // http://localhost:8080/jcat/admin
    path: "/jcat/admin",
    component: () => import("../views/jcat/JCATAdminView.vue"),
  },
  // AIFAN
  // 준비중
  // {
  //   path: "/aifan",
  //   component: () => import("../views/aifan/AIFAN_HomeView.vue"),
  // },
  // {
  //   path: "/aifan/policy",
  //   component: () => import("../views/aifan/AIFAN_PolicyView.vue"),
  // },
  // NFT sidnft-dev 용 서비스스
  // 준비중
  // TradePort 에서 생성함
  // https://www.tradeport.xyz/launchpad/create/edition?tab=mint-settings&collectionId=689cdbd8-0c92-499e-a77f-80941d659724&tokenId=02ebab7c-16c3-4d88-804d-bc46ed0202f6
  // {
  //   path: "/nft-dev/",
  //   component: () => import("../views/NftDevHomeView.vue"),
  // },
  // {
  //   path: "/nft-dev/detail/:id",
  //   component: () => import("../views/NftDeDetailView.vue"),
  // },
  // rpg2026
  {
    path: "/rpg2026",
    component: () => import("../views/rpg2026/RPG2026HomeView.vue"),
  },
  // 미누 가계부 앱
  {
    path: "/budget_app",
    component: () => import("../views/budget_app/BudgetAppHomeView.vue"),
  },
  {
    path: "/budget_app/policy",
    component: () => import("../views/budget_app/BudgetAppPolicyView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
